import { Dispatch, SetStateAction } from "react"
import { EcleanCuration } from "../GenerateDSComponents/Curate"
import InfoTooltip from "../../../../components/Buttons/InfoTooltip"
import ConditionalSelectField from "../../../../components/Form/ConditionSelectField"
import SelectField from "../../../../components/Form/SelectFields"

export default function StandardizeRegression({
    showSelect,
    form,
    setForm,
    fieldOptions,
    menuPortalTargetId,
}: {
    showSelect: boolean,
    form: EcleanCuration,
    setForm: Dispatch<SetStateAction<EcleanCuration>>,
    fieldOptions: {
        value: string,
        label: string
    }[],
    menuPortalTargetId: string,
}) {


    const handleSelectStdRegressionValues = (e: any, name: string) => {
        const value = e.value;

        if (form.eclean_std_regression !== null) {
            setForm({
                ...form,
                eclean_std_regression: {
                    ...form.eclean_std_regression,
                    [name]: value,
                },
                eclean_std_values: form.eclean_std_values ? {
                    ...form.eclean_std_values,
                    [name]: value,
                } : null,
                eclean_std_binary: form.eclean_std_binary ? {
                    ...form.eclean_std_binary,
                    [name]: value,
                } : null,
            })
        }
    }


    return (
        <>
        {form.eclean_std_regression !== null && (
            // Continuous only
            // If smiles string was previously standardized, set as smiles column
            <div className="flex flex-col gap-6 justify-start items-start">
                <div className="flex justify-start items-center gap-2">
                    <p className="text-default font-semibold">{form.eclean_std_smiles !== null ? '3' : '2'}. Standardize Regression</p>
                    <InfoTooltip 
                        btnWidth="14px"
                        title="Standardize Regression"
                        content={
                            <div className="flex flex-col gap-3 text-placeholder text-[12px]">
                                <p className="max-w-[300px]">This pipeline combines duplicates while keeping track of dropped data.</p>
                            </div>
                        }
                    />
                </div>
            
                <div className="w-full flex justify-between items-end gap-4">
                    <ConditionalSelectField label='Value Column' showSelect={showSelect}>
                        <SelectField 
                            label="Value Column"
                            id="value_column"
                            name="value_column"
                            value={form.eclean_std_regression.value_column ? { 
                                value: form.eclean_std_regression.value_column, 
                                label: form.eclean_std_regression.value_column 
                            } : null}
                            options={fieldOptions}
                            isRequired={true}
                            isCreatable={false}
                            isMulti={false}
                            handleChange={handleSelectStdRegressionValues}
                            menuPortalTarget={menuPortalTargetId ? document.getElementById(menuPortalTargetId) : document.getElementById('curate-ds-popup')}
                            />
                    </ConditionalSelectField>
                    <ConditionalSelectField label='Qualifier Column' showSelect={showSelect}>
                        <SelectField 
                            label="Qualifier Column"
                            id="qualifier_column"
                            name="qualifier_column"
                            value={form.eclean_std_regression.qualifier_column ? {
                                value: form.eclean_std_regression.qualifier_column, 
                                label: form.eclean_std_regression.qualifier_column 
                            } : null}
                            options={fieldOptions}
                            isRequired={false}
                            isCreatable={false}
                            isMulti={false}
                            handleChange={handleSelectStdRegressionValues}
                            menuPortalTarget={menuPortalTargetId ? document.getElementById(menuPortalTargetId) : document.getElementById('curate-ds-popup')}
                            />
                    </ConditionalSelectField>
                </div>

                {form.eclean_std_regression.smiles_column !== null && (
                <div className="w-full">
                    <SelectField 
                        label="Standardized SMILES Column"
                        id="smiles_column"
                        name="smiles_column"
                        value={{ 
                            value: form.eclean_std_regression.smiles_column, 
                            label: form.eclean_std_regression.smiles_column 
                        }}
                        options={fieldOptions}
                        isRequired={true}
                        isCreatable={false}
                        isMulti={false}
                        disabled
                        handleChange={() => {}}
                        menuPortalTarget={menuPortalTargetId ? document.getElementById(menuPortalTargetId) : document.getElementById('curate-ds-popup')}
                    />
                </div>
                )}
                
            </div>
        )}
        </>
    )
}